export default __webpack_public_path__ + "static/learn-coding-trait-d04402da206b20d2b1ed6840258174f3.webp";